<style lang="less" scoped>
.navMenu {position: absolute;top:0;/deep/.el-submenu {padding: 0px !important;text-align: left;width: 240px;background-color: #354053!important;/deep/ .el-menu.el-menu--inline {padding: 0;}}.el-menu-item {text-align: left;width: 240px;padding-left: 20px;}.is-active >span {color: #409EFF;}span {color: rgba(256, 256 ,256);}}
/deep/.el-submenu__title {background-color: #2b4063!important;} //二级菜单
/deep/.el-submenu__title:hover {background-image: linear-gradient(to right, #33548f, #354053)!important;}
/deep/.el-menu.el-menu--inline .el-menu-item {background-color: #222e3c!important;} //三级菜单
/deep/.el-menu.el-menu--inline .el-menu-item:hover {background-color: #33548f !important;}
/deep/.el-menu.el-menu--inline .el-menu-item.is-active {background-color: #33548f !important;}
.only {background-color: #2b4063 !important;}
.only:hover {background-image: linear-gradient(to right, #33548f, #354053)!important;}
.only.is-active {background-image: linear-gradient(to right, #33548f, #354053)!important;}
.top{height: 80px;text-align: left;margin-left: 20px;padding-top: 20px;}
.name{text-align: center;font-weight: bold;margin-bottom: -15px;margin-left: 10px;height: 100%;display: inline-block;overflow: hidden;line-height: 80px; cursor: pointer; }
.name:hover{color:#0a82f3;}
</style>

<template>
  <div class="navMenu">
    <div class="top">
      <img src="../../../../static/images/zlkindex/image.png" alt="">
      <span @click="upmessage" class="name">{{ admin }}</span>
    </div>
    <el-menu @select="handleOpen" @open="handleOpen"  @close="handleOpen" unique-opened router>
      <div v-for="(item, index) in navMenus" :key="index">
        <el-menu-item v-if="!item.childs && item.entity" :data="item" :index="item.entity.namee" class="only">
          <i :class="item.entity.icon"></i>
          <span slot="title">{{ item.entity.name }}</span>
        </el-menu-item>

        <el-submenu v-if="item.childs && item.entity" :data="item" :index="item.entity.namee">
          <template slot="title">
            <i :class="item.entity.icon"></i>
            <span> {{ item.entity.name }}</span>
          </template>

          <div v-for="(item2, index2) in item.childs" :key="index2">
            <el-menu-item v-if="!item2.childs && item2.entity" :data="item2" :index="item2.entity.namee">
              <i :class="item2.entity.icon"></i>
              <span slot="title">{{ item2.entity.name }}</span>
            </el-menu-item>

            <el-submenu v-if="item2.childs && item2.entity" :data="item2" :index="item2.entity.namee">
              <template slot="title">
                <i :class="item2.entity.icon"></i>
                <span> {{ item2.entity.name }}</span>
              </template>

              <div v-for="(item3, index3) in item2.childs" :key="index3">
                <el-menu-item v-if="!item3.childs && item3.entity" :data="item3" :index="item3.entity.namee">
                  <i :class="item3.entity.icon"></i>
                  <span slot="title">{{ item3.entity.name }}</span>
                </el-menu-item>
              </div>
            </el-submenu>
          </div>
        </el-submenu>
      </div>
    </el-menu>
  </div>
</template>

<script>
/**
 * 安进
 * 后台导航树组件
 */
export default {
  props: ['navMenus'],
  data()
  {
    return {
      admin: '',
      userid: ''
    }
  },
  created()
  {
    this.admin = JSON.parse(localStorage.getItem('userMsg')).username
    this.userid = JSON.parse(localStorage.getItem('userMsg')).userid
  },
  methods: {
    handleOpen(index)
    {
      this.$store.commit('onActiveName', '1')
      this.$store.commit('onIsLb', '1')
      let paras = {
        cmd: 'query',
        _major: 99,
        _minor: 19,
        _exp: 'namee = ?',
        types: 's',
        vals: index
      }
      window.post.getPost(paras).then((ret) =>
      {
        this.$store.commit('onNavID', ret[0].id)
      })
    },
    upmessage()
    {
      this.$router.push({path: '/UserUpdate', query: {id: this.userid}})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/backer/layout/NavMenu.vue